import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { State } from './state';
import { filtersReducer } from './filters/filters.reducer';
import { localFiltersReducer } from './local-filters/local-filters.reducer';
import { localStorageSync } from 'ngrx-store-localstorage';

export const reducers: ActionReducerMap<State> = {
  filters: filtersReducer,
  localFilters: localFiltersReducer,
};


export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [ 'localFilters' ],
    rehydrate: true,
    storageKeySerializer: () => 'app-local-filter/storage'
  })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [ localStorageSyncReducer ];
